import { FC } from 'react'
import { Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

interface IIsArabicCheckBoxProps {
  lang: string
  changeLangFunc: (lang: string) => void
}

const IsArabicCheckBox: FC<IIsArabicCheckBoxProps> = ({ changeLangFunc, lang }): JSX.Element => {
  const { t: tGeneral } = useTranslation('general')

  return (
    <Row>
      <div className='d-flex align-items-center'>
        <p className='my-2 mx-2'>{tGeneral('isArabic')}</p>
        <input
          checked={lang === 'ar'}
          type='checkbox'
          onChange={({ target }) => changeLangFunc(target.checked ? 'ar' : 'en')}
        />
      </div>
    </Row>
  )
}

export default IsArabicCheckBox
